// extracted by mini-css-extract-plugin
export default {"buttonWithoutEllipsis":"ResetSave_buttonWithoutEllipsis__eVR2y"};